var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.type=='VEHICLE')?_c('div',[_c('b-icon',{attrs:{"icon":"truck"}}),_vm._v(" "),_c('VehicleBrief',{attrs:{"label":_vm.data.id,"showGps":false,"showLink":false}})],1):_c('div',[_vm._v(" "+_vm._s(_vm.data.type)+"-"+_vm._s(_vm.data.id)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }